import { observer } from 'mobx-react-lite'
import { useEffect, useMemo } from 'react'
import classNames from 'classnames'
import { Error } from 'shared/ui'
import {
  useEventAttachmentUploadError,
  useEventAttachmentUploadSuccessful,
} from 'entities/Attachment'
import { useRinglessMessageFieldContext } from 'widgets/MessageFormFields/RinglessMessageField/context/ringlessMessageFieldContext'
import { RinglessMessageFieldActions } from 'widgets/MessageFormFields/RinglessMessageField/ui/RinglessMessageFieldActions/RinglessMessageFieldActions'
import { UploadingAudio } from 'widgets/MessageFormFields/RinglessMessageField/ui/UploadingAudio/UploadingAudio'
import { RinglessAudio } from 'widgets/MessageFormFields/RinglessMessageField/ui/RinglessAudio/RinglessAudio'
import styles from './styles.module.scss'

export type IRinglessMessageFieldContent = {
  border?: 'outlined' | 'default'
  dropdownWidth?: number
}

export const RinglessMessageFieldContent = observer(
  ({ border = 'default', dropdownWidth }: IRinglessMessageFieldContent) => {
    const {
      loadingAudio,
      onAttachmentUploadSuccessful,
      onAttachmentUploadError,
      attachment,
      reset,
      error,
    } = useRinglessMessageFieldContext()

    useEventAttachmentUploadSuccessful(onAttachmentUploadSuccessful)
    useEventAttachmentUploadError(onAttachmentUploadError)

    useEffect(() => reset, [])

    const isDefaultContent = !loadingAudio && !attachment

    const cardContent = useMemo(() => {
      if (loadingAudio) return <UploadingAudio />
      if (attachment) return <RinglessAudio />
      return null
    }, [loadingAudio, attachment])

    return (
      <div>
        {!isDefaultContent && (
          <div
            className={classNames(styles.wrap, styles.statecard, styles[`border${border}`], {
              [styles.error]: error,
            })}
          >
            {cardContent}
          </div>
        )}
        {isDefaultContent && <RinglessMessageFieldActions dropdownWidth={dropdownWidth} />}
        {error && (
          <div className={styles.wrapError}>
            <Error type={'text'} error={error} />
          </div>
        )}
      </div>
    )
  }
)
